import React, { useEffect, useState } from 'react'
import NavBar from '../components/NavBar/NavBar'
import { useParams } from 'react-router-dom'
import { supabase } from '../supabaseClient'
import VideoPlayer from '../components/VideoPlayer/VideoPlayer'
import CommentSection from '../components/CommentSection/CommentSection'

const Video = () => {
  const { id } = useParams()
  const [video, setVideo] = useState(null)

  const getVideo = async (videoId) => {
    try {
      const numericId = Number(videoId)

      // 1. Increment 'views' column in Supabase
      await supabase.rpc('increment_views', { video_id: numericId })

      // 2. Fetch updated record
      const { data, error } = await supabase
        .from('videos')
        .select('*')
        .eq('id', numericId)
        .maybeSingle()

      if (error) {
        console.error('Error fetching video:', error.message)
        return
      }

      setVideo(data)
    } catch (err) {
      console.error('Unexpected error:', err)
    }
  }

  useEffect(() => {
    if (id) {
      getVideo(id)
    }
  }, [id])

  return (
    <div>
      <NavBar />
      <div>
        <div className="h-12 sm:h-16 w-full"></div>
        <div className="h-full w-full flex">
          <div className="h-full w-60 hidden lg:block"></div>
          <div className="h-full grow">
            <VideoPlayer video={video} />
            <CommentSection video={video} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Video
